import { Checkbox } from "@material-ui/core";
import React from "react";
import KisshtTable from "./KisshtTable";

function CheckbokKisshtTable({
  data,
  columns,
  selected,
  handleSelect,
  checked = () => false,
  ...props
}) {
  const cehckBoxheader = {
    Header: () => (
      <Checkbox
        checked={data.length && data.length === selected.length}
        onChange={(e) => handleSelect(e.target.checked ? data : [])}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    ),
    accessor: "checkbox",
    Cell: (row) => (
      <Checkbox
        checked={checked(row, selected)}
        onChange={(e) => handleSelect(row, e.target.checked)}
        inputProps={{ "aria-label": "primary checkbox" }}
      />
    ),
    sortable: false,
  };
  return (
    <KisshtTable
      columns={[{ ...cehckBoxheader }, ...columns]}
      data={data}
      showPagination={false}
      {...props}
    />
  );
}

export default CheckbokKisshtTable;
